module.exports = __webpack_public_path__ + "static/media/logo-rtl.58b96dae.svg";